const getProctorMatrix = isMobile => ({
  thGuestSelectorTst: {
    value: 1
  },
  epHpDoneSearchTst: {
    value: +isMobile
  }
});

module.exports = getProctorMatrix;



// WEBPACK FOOTER //
// ./src/universal/utils/proctor.js